import Vue from 'vue';
import Vuex from 'vuex';

import clothesEn from '@/assets/data/en/clothes';
import estateEn from '@/assets/data/en/estate';
import clothesEs from '@/assets/data/es/clothes';
import estateEs from '@/assets/data/es/estate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: 'en',
    mode: document.location.hash !== '' ? 'estate' : 'clothes',
    content: {
      en: {
        clothes: clothesEn,
        estate: estateEn,
      },
      es: {
        clothes: clothesEs,
        estate: estateEs,
      },
    },
    contact: false,
  },
  mutations: {
    SET_MODE: (state, mode) => { state.mode = mode; },
    SWITCH_MODE: (state) => {
      state.mode = state.mode === 'clothes' ? 'estate' : 'clothes';
      if (state.mode === 'estate') document.location.hash = '#estate';
      else document.location.hash = '';
    },
    SET_CONTACT: (state, payload) => { state.contact = payload; },
    SET_LANG: (state, payload) => { state.lang = payload; },
  },
  actions: {
  },
  modules: {
  },
});
